import { Controller } from "@hotwired/stimulus"

// data-controller="nested-form"
// Use data attributes:
//   data-nested-form-index-value (optional auto increment seed)
// Targets: ["template", "container"]
// Each template element should have data-nested-form-template-param="membership" (or level)
export default class extends Controller {
  static targets = ["template", "container"]
  static values = { index: Number }

  connect() {
    if (!this.hasIndexValue) {
      this.indexValue = this.containerTargets.reduce((max, container) => {
        const existingIndex = parseInt(container.dataset.nestedFormIndex, 10)
        return Number.isNaN(existingIndex) ? max : Math.max(max, existingIndex)
      }, 0)
    }
  }

  add(event) {
    event.preventDefault()
    const templateId = event.params.template
    const containerName = event.params.container || "default"
    const templateTarget = this.templateTargets.find((template) => template.dataset.nestedFormTemplateParam === templateId)
    const containerTarget = this.containerTargets.find((element) => element.dataset.nestedFormContainerParam === containerName)

    if (!templateTarget || !containerTarget) { return }

    const index = this.nextIndex()
    const html = templateTarget.innerHTML.trim().replace(/__INDEX__/g, index)
    const fragment = document.createRange().createContextualFragment(html)
    const appended = containerTarget.appendChild(fragment.firstElementChild)
    appended.dataset.nestedFormIndex = index
    const eventName = containerTarget.dataset.nestedFormEventAdded || "nested-form:added"
    appended.dispatchEvent(new CustomEvent(eventName, { bubbles: true, detail: { index, container: containerName } }))
  }

  remove(event) {
    event.preventDefault()
    const wrapper = event.target.closest("[data-nested-form-index]")
    if (!wrapper) { return }

    const destroyCheckbox = wrapper.querySelector("input[type='checkbox'][name$='[_destroy]']")
    const destroyHiddenCustom = wrapper.querySelector("input[type='hidden'][name$='[_destroy]'][data-nested-form-destroy-field]")
    const destroyHiddenRails = wrapper.querySelector("input[type='hidden'][name$='[_destroy]']:not([data-nested-form-destroy-field])")

    if (destroyCheckbox || destroyHiddenCustom || destroyHiddenRails) {
      if (destroyCheckbox) {
        destroyCheckbox.checked = true
        destroyCheckbox.value = "1"
      }
      if (destroyHiddenCustom) {
        destroyHiddenCustom.value = "1"
        destroyHiddenCustom.defaultValue = "1"
        destroyHiddenCustom.setAttribute("value", "1")
      }
      if (destroyHiddenRails) {
        destroyHiddenRails.value = "1"
        destroyHiddenRails.disabled = false
      }

      wrapper.querySelectorAll('input, select, textarea').forEach((field) => {
        if (field === destroyCheckbox || field === destroyHiddenCustom || field === destroyHiddenRails) return
        field.disabled = true
        field.removeAttribute('required')
      })

      wrapper.classList.add("nested-form-removed")
      wrapper.setAttribute("aria-hidden", "true")
      wrapper.dataset.nestedFormRemoved = "true"
      wrapper.style.display = "none"
    } else {
      wrapper.remove()
    }

    const eventName = wrapper.dataset.nestedFormEventRemoved || "nested-form:removed"
    wrapper.dispatchEvent(new CustomEvent(eventName, { bubbles: true }))
  }

  nextIndex() {
    this.indexValue += 1
    return this.indexValue
  }
}
